var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md:grid grid-cols-2 mb-10 md:mb-16"},[_c('div',{staticClass:"text-sm md:text-base -md:mb-1"},[_vm._v(_vm._s(_vm.list.label))]),_vm._v(" "),_c('AtomList',{attrs:{"list":_vm.list.list}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }